import { render, staticRenderFns } from "./cxdetail.vue?vue&type=template&id=2ed80156&scoped=true"
import script from "./cxdetail.vue?vue&type=script&lang=js"
export * from "./cxdetail.vue?vue&type=script&lang=js"
import style0 from "./cxdetail.vue?vue&type=style&index=0&id=2ed80156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed80156",
  null
  
)

export default component.exports